import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import Popover from '@/shared/components/popover/index.vue';
import store from '@/trust-atcs-app/store';
import { PopoverView } from '@/shared/components/popover/popover';
import RadioButtonHorizontal from '../radiobutton-horizontal/index.vue';
import { orderBy } from 'lodash';

@Options<RadioButtonSubQuestions>({
  components: {
    RadioButtonHorizontal,
    Popover
  }
})
export default class RadioButtonSubQuestions extends Vue {

  @Prop()
  private question!: any;

  @Watch('selectedOption')
  private onSelectedOptionChanged(): void {
    // reset all selection
    this.question.responses.forEach((r: any, i: number) => {
      this.question.responses[i].answerTxt = null;
    });

    // search and select
    // this.question.responses.forEach((r: any, i: number) => {
    //   if (r.value == this.selectedOption) {
    //     this.question.responses[i].answerTxt = true;
    //   }
    // });

    if (this.selectedOption != this.question.subQuestionTriggerValue) {
      this.question.atcsSubQuestions.forEach((r: any, i: number) => {
        this.question.atcsSubQuestions[i].responses[0].answerTxt = null;
        this.question.atcsSubQuestions[i].responses.forEach((r: any, j: number) => {
          this.question.atcsSubQuestions[i].responses[j].answerIsSelected = null;
        });
      });
      this.subQuestionAnswers = this.question.atcsSubQuestions.map((x: any) => x.responses[0].answerTxt);
    }

    // if (this.selectedOption == this.question.subQuestionTriggerValue && this.question.atcsSubQuestions?.length == 1) {
    //   this.question.atcsSubQuestions[0].responses[0].answerTxt = true;
    // }

    this.question.responses.forEach((r: any, i: number) => {
      if (r.value == this.selectedOption) {
        this.question.responses[i].answerIsSelected = true;
      } else {
        this.question.responses[i].answerIsSelected = null;
      }
    });

    this.$emit('validForm', this.validForm());
  }

  private uniqueIdName = null as any;
  private selectedOption = null as any;
  private newWording = '';
  private obj: PopoverView = null as any;
  private subQuestionAnswers: any[] = [];

  created(): void {
    this.uniqueIdName = 'RadioButtonBranchList' + this.question.id;
    this.initField();
    const content = store.getters.getPopovers;
    this.newWording = this.question.wording;
    if (this.question.wording.match(/--{{([^)]+)}}--/)) {
      const popovers = this.question.wording.match(/--{{([^)]+)}}--/)[1];
      this.obj = content.filter((x: any) => x.key == popovers)[0];
      this.newWording = this.question.wording.replace('--{{' + popovers + '}}--', '');
    }
  }

  private initField(): void {
    this.question.responses = orderBy(this.question.responses, 'order', 'asc'); 
    const defaultSelection = this.question.responses.filter((x: any) => x.answerIsSelected);
    if (defaultSelection.length > 0) {
      this.selectedOption = defaultSelection[0].value;
    }
    // this.subQuestionAnswers = this.question.atcsSubQuestions.map((x: any) => x.responses[0].answerTxt);
    this.$emit('validForm', this.validForm());
  }

  private updateSubQuestionAnswer(event: any, i: number): void {
    this.$emit('validForm', this.validForm());
  }

  private validSubForm() {
    this.$emit('validForm', this.validForm());
  }

  private validForm(): boolean {
    let valid = false;
    let subResponses: any[] = [];
    if (this.selectedOption == this.question.subQuestionTriggerValue && this.question.atcsSubQuestions[0]) {
      switch (this.question.atcsSubQuestions[0].atcsQuestionTypeId) {
        case 10:
          subResponses = this.question.atcsSubQuestions[0].responses.filter((x: any) => x.answerIsSelected == true);
          valid = subResponses.length > 0;
          break;
        case 2:
          valid = this.question.atcsSubQuestions.every((subQuestion: { responses: { answerTxt: string; }[]; }) =>
            subQuestion.responses[0].answerTxt !== null && subQuestion.responses[0].answerTxt !== ''
          );
          break;
        default:
          break;
      }
    } else if (this.selectedOption != this.question.subQuestionTriggerValue) {
      valid = this.question.responses.filter((x: any) => x.value == this.selectedOption)?.length > 0;
    }
    return valid;
  }
}
